import type { CollectibleElastic, CollectibleElasticParam } from "@/services/collectibles/elastic/collectiblesElasticTypes";
import { gettext } from "@/services/translation";

export const getCollectibleElasticParams = (colletibleElastic: CollectibleElastic): CollectibleElasticParam[] => {
  const params: CollectibleElasticParam[] = [];

  const theme = colletibleElastic.theme;
  if (theme !== null) {
    params.push({
      name: gettext.$gettext("Edice"),
      value: theme.name,
    });
  }

  colletibleElastic.parameters.forEach((param) => {
    const value = param.value === null ? undefined : param.value;
    const name = param.name;
    params.push({ name, value });
  });

  return params;
};
